export enum OnboardingModuleEnum {
    // Painel
    DASHBOARD = 'dashboard',
    DRIVERS = 'drivers',
    RIDERS = 'riders',
    VEHICLES = 'vehicles',
    RIDES = 'rides',
    MAPS = 'maps',
    RATINGS = 'ratings',
    SETTINGS = 'settings',
    SETTINGS_GENERAL = 'settings_general',
    SETTINGS_MERCADOPAGO = 'settings_mercadopago',
    SETTINGS_CATEGORIES = 'settings_categories',
    SETTINGS_VEHICLE_TYPES = 'settings_vehicle_types',
    SETTINGS_COVERAGE = 'settings_coverage',
    SETTINGS_PAYMENT = 'settings_payment',
    // Driver App
    DRIVER_MAP = 'driver_map',
    DRIVER_PROFILE = 'driver_profile',
    DRIVER_VEHICLE = 'driver_vehicle',
    DRIVER_WALLET = 'driver_wallet',
    DRIVER_PAYMENT = 'driver_payment',
    // Rider App
    RIDER_MAP = 'rider_map',
    RIDER_PROFILE = 'rider_profile',
    RIDER_RIDES = 'rider_rides',
}

export type OnboardingStepDTO = {
    id: string;
    title: string;
    description: string;
    /** DOM element id (web) or testID (React Native) to highlight */
    targetId?: string;
    /** Tooltip position relative to the target element */
    position?: 'top' | 'bottom' | 'left' | 'right' | 'center';
    /** Icon name from react-icons (web) or MaterialIcons (RN) */
    icon?: string;
};

export type OnboardingConfigDTO = {
    module: OnboardingModuleEnum;
    steps: OnboardingStepDTO[];
};
